import React from 'react';
import { View } from 'react-native';

import { Text, UberEatsLogo, createMqStyles, tokens } from '@fhs/ui';

export const DeliveryPoweredBy: React.VFC = () => {
  const styles = useDeliveryPoweredByMqStyles();

  return (
    <View
      style={styles.row}
      accessible
      accessibilityRole="image"
      accessibilityLabel="Delivery powered by Uber Eats"
      testID="store-locator-delivery-powered-by"
    >
      <Text.Ui size="xs" style={styles.label}>
        Delivery Powered By:
      </Text.Ui>
      {/*
       * The wordmark sits in a 16:9 canvas with wide margins above and below it. `cover` crops
       * those margins so the visible logo fills the slot the design gives it.
       */}
      <UberEatsLogo contentFit="cover" style={styles.logo} aria-hidden />
    </View>
  );
};

const useDeliveryPoweredByMqStyles = createMqStyles({
  row: {
    $base: {
      alignItems: 'center',
      alignSelf: 'flex-start',
      flexDirection: 'row',
      gap: 4,
    },
  },
  label: {
    $base: {
      color: tokens.colors.$blackOpacity75,
    },
  },
  logo: {
    $base: {
      height: 16,
      width: 78,
    },
    $gteDesktop: {
      height: 17,
      width: 80,
    },
  },
});
